import React, { useEffect, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';

import css from '../nibTable.module.sass';

const EyeCell = ({ value: initialValue, row: { index }, column: { id }, rowToEdit, updateMyData, data }) => {
  const [value, setValue] = useState(initialValue);

  const onClick = () => {
    if (data.onClick) {
      data.onClick(value);
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <IconButton className={css.eyeCell} onClick={onClick} disabled={!value}>
      <VisibilityIcon />
    </IconButton>
  );
};

export default EyeCell;
